import { RegionShared } from "@1games-ru/region-shared";
import { RpcMpProviderFailedResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-failed-response.ts";
import { RpcMpProviderSuccessResponse } from "@/core/rpc-mp-provider/responses/rpc-mp-provider-success-response.ts";
import RpcMpProvider from "@/core/rpc-mp-provider/rpc-mp-provider.ts";

export default class TfaMpProvider {
  public static async getAuthenticatorQr(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.GoogleEnableSendResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.GoogleEnableSendRequest,
      typeof RegionShared.Backend.Responses.GoogleEnableSendResponse
    >(RegionShared.Backend.Events.Account.TwoFactorGoogleEnableSend, {});
  }

  public static async checkGoogleCode(
    code: string,
    goal:
      | typeof RegionShared.Backend.Events.Auth.RecoveryGoogleCheck
      | typeof RegionShared.Backend.Events.Account.TwoFactorGoogleEnableCheck
      | typeof RegionShared.Backend.Events.Account.TwoFactorGoogleDisableCheck,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Responses.RecoveryCheckGoogleResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Requests.RecoveryCheckGoogleRequest,
      typeof RegionShared.Responses.RecoveryCheckGoogleResponse
    >(goal, {
      code,
    });
  }

  public static async sendSmsCode(
    phoneNumber: string,
    goal:
      | typeof RegionShared.Backend.Events.Auth.RecoverySmsSend
      | typeof RegionShared.Backend.Events.Account.TwoFactorSmsEnableSend
      | typeof RegionShared.Backend.Events.Account.TwoFactorSmsDisableSend,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.RecoverySmsSendResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.RecoverySmsSendRequest,
      typeof RegionShared.Backend.Responses.RecoverySmsSendResponse
    >(goal, {
      phoneNumber,
    });
  }

  public static async checkSmsCode(
    code: string,
    goal:
      | typeof RegionShared.Backend.Events.Auth.RecoverySmsCheck
      | typeof RegionShared.Backend.Events.Account.TwoFactorSmsEnableCheck
      | typeof RegionShared.Backend.Events.Account.TwoFactorSmsDisableCheck,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Responses.RecoverySmsCheckResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.RecoverySmsCheckRequest,
      typeof RegionShared.Backend.Responses.RecoverySmsCheckResponse
    >(goal, {
      code,
    });
  }

  public static async sendEmailCode(
    email: string,
    goal:
      | typeof RegionShared.Backend.Events.Auth.RecoveryEmailSend
      | typeof RegionShared.Backend.Events.Account.TwoFactorEmailEnableSend
      | typeof RegionShared.Backend.Events.Account.TwoFactorEmailDisableSend,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Responses.RecoveryEmailSendResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.RecoveryEmailSendRequest,
      typeof RegionShared.Backend.Responses.RecoveryEmailSendResponse
    >(goal, {
      email,
    });
  }

  public static async checkEmailCode(
    code: string,
    goal:
      | typeof RegionShared.Backend.Events.Auth.RecoveryEmailCheck
      | typeof RegionShared.Backend.Events.Account.TwoFactorEmailEnableCheck
      | typeof RegionShared.Backend.Events.Account.TwoFactorEmailDisableCheck,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Responses.RecoveryEmailCheckResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.RecoveryEmailCheckRequest,
      typeof RegionShared.Backend.Responses.RecoveryEmailCheckResponse
    >(goal, {
      code,
    });
  }

  public static async sendLogInCode(
    data: typeof RegionShared.Backend.Requests.TwoFactorLoginResendRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<
        typeof RegionShared.Backend.Responses.TwoFactorLoginResendResponse
      >
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.TwoFactorLoginResendRequest,
      typeof RegionShared.Backend.Responses.TwoFactorLoginResendResponse
    >(RegionShared.Backend.Events.Auth.TwoFactorLoginResend, data);
  }

  public static async checkLogInCode(
    data: typeof RegionShared.Backend.Requests.TwoFactorLoginCheckRequest,
  ): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Responses.TwoFactorLoginCheckResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.TwoFactorLoginCheckRequest,
      typeof RegionShared.Backend.Responses.TwoFactorLoginCheckResponse
    >(RegionShared.Backend.Events.Auth.TwoFactorLoginCheck, data);
  }

  public static async nextLogIn(): Promise<
    | RpcMpProviderFailedResponse
    | RpcMpProviderSuccessResponse<typeof RegionShared.Backend.Responses.TwoFactorLoginNextResponse>
  > {
    return RpcMpProvider.getInstance().callServer<
      typeof RegionShared.Backend.Requests.TwoFactorLoginNextRequest,
      typeof RegionShared.Backend.Responses.TwoFactorLoginNextResponse
    >(RegionShared.Backend.Events.Auth.TwoFactorLoginNext, {});
  }
}
